import { render, staticRenderFns } from "./CPBasketBuy.vue?vue&type=template&id=773574bf&scoped=true&"
import script from "./CPBasketBuy.vue?vue&type=script&lang=ts&"
export * from "./CPBasketBuy.vue?vue&type=script&lang=ts&"
import style0 from "./CPBasketBuy.vue?vue&type=style&index=0&id=773574bf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773574bf",
  null
  
)

export default component.exports